import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTruckBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 15,
		height: 15,
		rx: 3.5,
		stroke: "#666666"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.9665 9.47648L12.6855 8.81789L12.1873 7.65C11.7595 6.64758 10.7393 6 9.5875 6H6.4125C5.261 6 4.2405 6.64758 3.81275 7.65L3.3145 8.81789L3.0335 9.47648C2.4305 9.69141 2 10.2342 2 10.875V12C2 12.3778 2.154 12.7188 2.4 12.9827V14.25C2.4 14.6641 2.75825 15 3.2 15H4C4.44175 15 4.8 14.6641 4.8 14.25V13.5H11.2V14.25C11.2 14.6641 11.5583 15 12 15H12.8C13.2417 15 13.6 14.6641 13.6 14.25V12.9827C13.846 12.7191 14 12.378 14 12V10.875C14 10.2342 13.5695 9.69141 12.9665 9.47648ZM5.29825 8.20711C5.4805 7.78008 5.92175 7.5 6.4125 7.5H9.5875C10.0782 7.5 10.5195 7.78008 10.7018 8.20711L11.2 9.375H4.8L5.29825 8.20711ZM4 11.9953C3.52 11.9953 3.2 11.6962 3.2 11.2477C3.2 10.7991 3.52 10.5 4 10.5C4.48 10.5 5.2 11.1729 5.2 11.6215C5.2 12.0701 4.48 11.9953 4 11.9953ZM12 11.9953C11.52 11.9953 10.8 12.0701 10.8 11.6215C10.8 11.1729 11.52 10.5 12 10.5C12.48 10.5 12.8 10.7991 12.8 11.2477C12.8 11.6962 12.48 11.9953 12 11.9953Z",
		fill: "#666666"
	})]
});
export default SvgTruckBox;
